import React, { Children, isValidElement } from 'react';
import {
  Card,
  CardProps,
  EmptyState as WSREmptyState,
  TextButton,
} from '@wix/design-system';
import { Refresh as RefreshIcon } from '@wix/wix-ui-icons-common';

export interface ErrorCardProps extends CardProps {
  /**
   * Function, which will be executed on `Try Again` click.
   */
  onRetry?: () => void;
  /**
   * Error state title
   */
  title?: string;
  /**
   * Error state subtitle
   */
  subtitle?: string;
  /**
   * Error state `Try Again` button text
   */
  retryText?: string;
}
export function ErrorCard({
  onRetry,
  children,
  title,
  subtitle,
  retryText,
  ...rest
}: ErrorCardProps & { children?: React.ReactNode }) {
  const childrenArray = Children.toArray(children);

  return (
    <Card {...rest}>
      {childrenArray.filter(
        (el) =>
          isValidElement(el) &&
          (el.type as any)?.displayName !== 'Card.Content',
      )}
      <Card.Content>
        <WSREmptyState
          dataHook="error-card-state"
          title={title}
          subtitle={subtitle}
        >
          <TextButton
            dataHook="error-card-state-retry-button"
            prefixIcon={<RefreshIcon />}
            onClick={onRetry}
          >
            {retryText}
          </TextButton>
        </WSREmptyState>
      </Card.Content>
    </Card>
  );
}
